import { OrganizationTypes } from '@platform/client';
import { FormsInputDropdown } from '@platform/components';
import { Control, FieldError, FieldValues, Path, RegisterOptions } from 'react-hook-form';

type OrganizationTypeSelectionDropdownProps<FData extends FieldValues> = {
  control: Control<FData>;
  rules?: RegisterOptions<FData>;
  label: string;
  errors?: FieldError;
  name: Path<FData>;
  hintText?: string;
  placeholder?: string;
};

export const OrgTypeSelectionDropdown = <FData extends FieldValues>(
  props: OrganizationTypeSelectionDropdownProps<FData>,
) => {
  const { control, label, name, rules, hintText, errors, placeholder } = props;

  const organizationTypes = OrganizationTypes.useGetOrganizationTypes().data || [];

  const orgTypeItems = organizationTypes.map((type) => ({
    text: type.name || '',
    textValue: type.id,
  }));

  return (
    <FormsInputDropdown
      control={control}
      name={name}
      label={label}
      placeholder={placeholder || 'Select one'}
      items={orgTypeItems}
      error={errors}
      rules={rules}
      hintText={hintText}
      type='default'
    />
  );
};
